export const ROLES = ["user", "admin", "platform_operator", "platform_admin"] as const
export type Role = (typeof ROLES)[number]

const ROLE_HIERARCHY: Record<Role, number> = {
	user: 0,
	admin: 1,
	platform_operator: 2,
	platform_admin: 3,
}

export function parseRoles(metadata: unknown): Role[] {
	if (!metadata || typeof metadata !== "object") return []
	const md = metadata as Record<string, unknown>
	if (!Array.isArray(md.roles)) return []
	return md.roles.filter((r): r is Role => ROLES.includes(r as Role))
}

export function hasRole(roles: Role[], required: Role): boolean {
	return roles.some((r) => ROLE_HIERARCHY[r] >= ROLE_HIERARCHY[required])
}
